// frontend/src/pages/Verify.jsx

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axiosConfig";

export default function Verify() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    axios
      .get("/whoami")
      .then((res) => setUser(res.data?.user || null))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="pt-20 text-center">Loading…</div>;

  // If somehow not logged in, push to login
  if (!user?._id) {
    window.location.href = "/login";
    return null;
  }

  // If already verified, go home/dashboard
  if (user.isKycVerified) {
    window.location.href = "/dashboard";
    return null;
  }

  const submitted = Boolean(user.kycSubmittedAt);
  const rejected = Boolean(user.kycRejectedAt);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow p-6 sm:p-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
          Complete Verification to Continue
        </h1>

        <p className="mt-2 text-slate-600">
          Your account is logged in, but KYC is not verified. You won’t be able to access
          the app until verification is completed.
        </p>

        <div className="mt-6 rounded-xl border border-slate-200 p-4">
          <div className="font-semibold text-slate-800">Status</div>
          <div className="mt-1 text-slate-700">
            {rejected
              ? "Rejected — please resubmit"
              : submitted
              ? "Submitted — pending approval"
              : "Not submitted"}
          </div>

          {rejected && user.kycRejectedReason ? (
            <div className="mt-2 text-sm text-red-600">
              Reason: {user.kycRejectedReason}
            </div>
          ) : null}
        </div>

        <div className="mt-6 space-y-3">
          <div className="rounded-xl border border-slate-200 p-4">
            <div className="font-semibold text-slate-800">Step 1</div>
            <div className="text-slate-600">Submit your KYC details</div>
          </div>

          <div className="rounded-xl border border-slate-200 p-4">
            <div className="font-semibold text-slate-800">Step 2</div>
            <div className="text-slate-600">Wait for approval by our team</div>
          </div>
        </div>

        <button
          onClick={() => navigate("/profile")}
          className="mt-8 w-full rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3"
        >
          Go to Verification (KYC) Page
        </button>

        <p className="mt-3 text-xs text-slate-500 text-center">
          Until KYC is verified, all other sections are blocked.
        </p>
      </div>
    </div>
  );
}
